import { MetaDataBox, ProjectMetaBox, RootBox, SelectionBox, UserInterfaceBox, UploadFileBox, ShadertoyBox, MIDIControllerBox, TimelineBox, TrackBox, NoteEventBox, NoteEventRepeatBox, NoteEventCollectionBox, NoteRegionBox, NoteClipBox, ValueEventBox, ValueEventCollectionBox, ValueEventCurveBox, ValueRegionBox, ValueClipBox, SignatureEventBox, AudioRegionBox, AudioClipBox, AudioPitchStretchBox, AudioTimeStretchBox, AudioSignalsmithBox, TransientMarkerBox, WarpMarkerBox, MarkerBox, AudioFileBox, SoundfontFileBox, NeuralAmpModelBox, AudioUnitBox, CaptureAudioBox, CaptureMidiBox, AudioBusBox, AuxSendBox, GrooveShuffleBox, LfoModulatorBox, StepsModulatorBox, MacroModulatorBox, RandomModulatorBox, ModulationBox, UnknownAudioEffectDeviceBox, UnknownMidiEffectDeviceBox, DeviceInterfaceKnobBox, ModularDeviceBox, StereoToolDeviceBox, MaximizerDeviceBox, CompressorDeviceBox, GateDeviceBox, DelayDeviceBox, AutotuneDeviceBox, CrusherDeviceBox, DattorroReverbDeviceBox, ConvolverDeviceBox, VelocityDeviceBox, FoldDeviceBox, TidalDeviceBox, RevampDeviceBox, ReverbDeviceBox, VaporisateurDeviceBox, MIDIOutputDeviceBox, MIDIOutputBox, MIDIOutputParameterBox, SoundfontDeviceBox, NeonDeviceBox, NanoDeviceBox, PlayfieldDeviceBox, PlayfieldSampleBox, TapeDeviceBox, ArpeggioDeviceBox, PitchDeviceBox, ZeitgeistDeviceBox, NeuralAmpDeviceBox, VocoderDeviceBox, WaveshaperDeviceBox, WerkstattDeviceBox, WerkstattParameterBox, WerkstattSampleBox, SpielwerkDeviceBox, ApparatDeviceBox, CubedDeviceBox, NoopInstrumentBox, CompositeDeviceBox, CompositeCellBox, AudioEffectCompositeBox, AudioEffectCompositeCellBox, StereoCompositeBox, FrequencySplitBox, ModularBox, ModuleConnectionBox, ModularAudioInputBox, ModularAudioOutputBox, ModuleDelayBox, ModuleMultiplierBox, ModuleGainBox, } from ".";
import { ByteArrayInput, panic, UUID } from "@opendaw/lib-std";
//
//   ___          ___
//  | _ ) _____ _| __|__ _ _ __ _ ___
//  | _ \/ _ \ \ / _/ _ \ '_/ _` / -_)
//  |___/\___/_\_\_|\___/_| \__, \___|
//                         |___/
//
//  auto-generated | do not edit | blame andre.michelle@opendaw.org
//
export var BoxIO;
(function (BoxIO) {
    BoxIO.names = [
        "MetaDataBox",
        "ProjectMetaBox",
        "RootBox",
        "SelectionBox",
        "UserInterfaceBox",
        "UploadFileBox",
        "ShadertoyBox",
        "MIDIControllerBox",
        "TimelineBox",
        "TrackBox",
        "NoteEventBox",
        "NoteEventRepeatBox",
        "NoteEventCollectionBox",
        "NoteRegionBox",
        "NoteClipBox",
        "ValueEventBox",
        "ValueEventCollectionBox",
        "ValueEventCurveBox",
        "ValueRegionBox",
        "ValueClipBox",
        "SignatureEventBox",
        "AudioRegionBox",
        "AudioClipBox",
        "AudioPitchStretchBox",
        "AudioTimeStretchBox",
        "AudioSignalsmithBox",
        "TransientMarkerBox",
        "WarpMarkerBox",
        "MarkerBox",
        "AudioFileBox",
        "SoundfontFileBox",
        "NeuralAmpModelBox",
        "AudioUnitBox",
        "CaptureAudioBox",
        "CaptureMidiBox",
        "AudioBusBox",
        "AuxSendBox",
        "GrooveShuffleBox",
        "LfoModulatorBox",
        "StepsModulatorBox",
        "MacroModulatorBox",
        "RandomModulatorBox",
        "ModulationBox",
        "UnknownAudioEffectDeviceBox",
        "UnknownMidiEffectDeviceBox",
        "DeviceInterfaceKnobBox",
        "ModularDeviceBox",
        "StereoToolDeviceBox",
        "MaximizerDeviceBox",
        "CompressorDeviceBox",
        "GateDeviceBox",
        "DelayDeviceBox",
        "AutotuneDeviceBox",
        "CrusherDeviceBox",
        "DattorroReverbDeviceBox",
        "ConvolverDeviceBox",
        "VelocityDeviceBox",
        "FoldDeviceBox",
        "TidalDeviceBox",
        "RevampDeviceBox",
        "ReverbDeviceBox",
        "VaporisateurDeviceBox",
        "MIDIOutputDeviceBox",
        "MIDIOutputBox",
        "MIDIOutputParameterBox",
        "SoundfontDeviceBox",
        "NeonDeviceBox",
        "NanoDeviceBox",
        "PlayfieldDeviceBox",
        "PlayfieldSampleBox",
        "TapeDeviceBox",
        "ArpeggioDeviceBox",
        "PitchDeviceBox",
        "ZeitgeistDeviceBox",
        "NeuralAmpDeviceBox",
        "VocoderDeviceBox",
        "WaveshaperDeviceBox",
        "WerkstattDeviceBox",
        "WerkstattParameterBox",
        "WerkstattSampleBox",
        "SpielwerkDeviceBox",
        "ApparatDeviceBox",
        "CubedDeviceBox",
        "NoopInstrumentBox",
        "CompositeDeviceBox",
        "CompositeCellBox",
        "AudioEffectCompositeBox",
        "AudioEffectCompositeCellBox",
        "StereoCompositeBox",
        "FrequencySplitBox",
        "ModularBox",
        "ModuleConnectionBox",
        "ModularAudioInputBox",
        "ModularAudioOutputBox",
        "ModuleDelayBox",
        "ModuleMultiplierBox",
        "ModuleGainBox",
    ];
    BoxIO.create = (name, graph, uuid, constructor) => {
        switch (name) {
            case "MetaDataBox":
                return MetaDataBox.create(graph, uuid, constructor);
            case "ProjectMetaBox":
                return ProjectMetaBox.create(graph, uuid, constructor);
            case "RootBox":
                return RootBox.create(graph, uuid, constructor);
            case "SelectionBox":
                return SelectionBox.create(graph, uuid, constructor);
            case "UserInterfaceBox":
                return UserInterfaceBox.create(graph, uuid, constructor);
            case "UploadFileBox":
                return UploadFileBox.create(graph, uuid, constructor);
            case "ShadertoyBox":
                return ShadertoyBox.create(graph, uuid, constructor);
            case "MIDIControllerBox":
                return MIDIControllerBox.create(graph, uuid, constructor);
            case "TimelineBox":
                return TimelineBox.create(graph, uuid, constructor);
            case "TrackBox":
                return TrackBox.create(graph, uuid, constructor);
            case "NoteEventBox":
                return NoteEventBox.create(graph, uuid, constructor);
            case "NoteEventRepeatBox":
                return NoteEventRepeatBox.create(graph, uuid, constructor);
            case "NoteEventCollectionBox":
                return NoteEventCollectionBox.create(graph, uuid, constructor);
            case "NoteRegionBox":
                return NoteRegionBox.create(graph, uuid, constructor);
            case "NoteClipBox":
                return NoteClipBox.create(graph, uuid, constructor);
            case "ValueEventBox":
                return ValueEventBox.create(graph, uuid, constructor);
            case "ValueEventCollectionBox":
                return ValueEventCollectionBox.create(graph, uuid, constructor);
            case "ValueEventCurveBox":
                return ValueEventCurveBox.create(graph, uuid, constructor);
            case "ValueRegionBox":
                return ValueRegionBox.create(graph, uuid, constructor);
            case "ValueClipBox":
                return ValueClipBox.create(graph, uuid, constructor);
            case "SignatureEventBox":
                return SignatureEventBox.create(graph, uuid, constructor);
            case "AudioRegionBox":
                return AudioRegionBox.create(graph, uuid, constructor);
            case "AudioClipBox":
                return AudioClipBox.create(graph, uuid, constructor);
            case "AudioPitchStretchBox":
                return AudioPitchStretchBox.create(graph, uuid, constructor);
            case "AudioTimeStretchBox":
                return AudioTimeStretchBox.create(graph, uuid, constructor);
            case "AudioSignalsmithBox":
                return AudioSignalsmithBox.create(graph, uuid, constructor);
            case "TransientMarkerBox":
                return TransientMarkerBox.create(graph, uuid, constructor);
            case "WarpMarkerBox":
                return WarpMarkerBox.create(graph, uuid, constructor);
            case "MarkerBox":
                return MarkerBox.create(graph, uuid, constructor);
            case "AudioFileBox":
                return AudioFileBox.create(graph, uuid, constructor);
            case "SoundfontFileBox":
                return SoundfontFileBox.create(graph, uuid, constructor);
            case "NeuralAmpModelBox":
                return NeuralAmpModelBox.create(graph, uuid, constructor);
            case "AudioUnitBox":
                return AudioUnitBox.create(graph, uuid, constructor);
            case "CaptureAudioBox":
                return CaptureAudioBox.create(graph, uuid, constructor);
            case "CaptureMidiBox":
                return CaptureMidiBox.create(graph, uuid, constructor);
            case "AudioBusBox":
                return AudioBusBox.create(graph, uuid, constructor);
            case "AuxSendBox":
                return AuxSendBox.create(graph, uuid, constructor);
            case "GrooveShuffleBox":
                return GrooveShuffleBox.create(graph, uuid, constructor);
            case "LfoModulatorBox":
                return LfoModulatorBox.create(graph, uuid, constructor);
            case "StepsModulatorBox":
                return StepsModulatorBox.create(graph, uuid, constructor);
            case "MacroModulatorBox":
                return MacroModulatorBox.create(graph, uuid, constructor);
            case "RandomModulatorBox":
                return RandomModulatorBox.create(graph, uuid, constructor);
            case "ModulationBox":
                return ModulationBox.create(graph, uuid, constructor);
            case "UnknownAudioEffectDeviceBox":
                return UnknownAudioEffectDeviceBox.create(graph, uuid, constructor);
            case "UnknownMidiEffectDeviceBox":
                return UnknownMidiEffectDeviceBox.create(graph, uuid, constructor);
            case "DeviceInterfaceKnobBox":
                return DeviceInterfaceKnobBox.create(graph, uuid, constructor);
            case "ModularDeviceBox":
                return ModularDeviceBox.create(graph, uuid, constructor);
            case "StereoToolDeviceBox":
                return StereoToolDeviceBox.create(graph, uuid, constructor);
            case "MaximizerDeviceBox":
                return MaximizerDeviceBox.create(graph, uuid, constructor);
            case "CompressorDeviceBox":
                return CompressorDeviceBox.create(graph, uuid, constructor);
            case "GateDeviceBox":
                return GateDeviceBox.create(graph, uuid, constructor);
            case "DelayDeviceBox":
                return DelayDeviceBox.create(graph, uuid, constructor);
            case "AutotuneDeviceBox":
                return AutotuneDeviceBox.create(graph, uuid, constructor);
            case "CrusherDeviceBox":
                return CrusherDeviceBox.create(graph, uuid, constructor);
            case "DattorroReverbDeviceBox":
                return DattorroReverbDeviceBox.create(graph, uuid, constructor);
            case "ConvolverDeviceBox":
                return ConvolverDeviceBox.create(graph, uuid, constructor);
            case "VelocityDeviceBox":
                return VelocityDeviceBox.create(graph, uuid, constructor);
            case "FoldDeviceBox":
                return FoldDeviceBox.create(graph, uuid, constructor);
            case "TidalDeviceBox":
                return TidalDeviceBox.create(graph, uuid, constructor);
            case "RevampDeviceBox":
                return RevampDeviceBox.create(graph, uuid, constructor);
            case "ReverbDeviceBox":
                return ReverbDeviceBox.create(graph, uuid, constructor);
            case "VaporisateurDeviceBox":
                return VaporisateurDeviceBox.create(graph, uuid, constructor);
            case "MIDIOutputDeviceBox":
                return MIDIOutputDeviceBox.create(graph, uuid, constructor);
            case "MIDIOutputBox":
                return MIDIOutputBox.create(graph, uuid, constructor);
            case "MIDIOutputParameterBox":
                return MIDIOutputParameterBox.create(graph, uuid, constructor);
            case "SoundfontDeviceBox":
                return SoundfontDeviceBox.create(graph, uuid, constructor);
            case "NeonDeviceBox":
                return NeonDeviceBox.create(graph, uuid, constructor);
            case "NanoDeviceBox":
                return NanoDeviceBox.create(graph, uuid, constructor);
            case "PlayfieldDeviceBox":
                return PlayfieldDeviceBox.create(graph, uuid, constructor);
            case "PlayfieldSampleBox":
                return PlayfieldSampleBox.create(graph, uuid, constructor);
            case "TapeDeviceBox":
                return TapeDeviceBox.create(graph, uuid, constructor);
            case "ArpeggioDeviceBox":
                return ArpeggioDeviceBox.create(graph, uuid, constructor);
            case "PitchDeviceBox":
                return PitchDeviceBox.create(graph, uuid, constructor);
            case "ZeitgeistDeviceBox":
                return ZeitgeistDeviceBox.create(graph, uuid, constructor);
            case "NeuralAmpDeviceBox":
                return NeuralAmpDeviceBox.create(graph, uuid, constructor);
            case "VocoderDeviceBox":
                return VocoderDeviceBox.create(graph, uuid, constructor);
            case "WaveshaperDeviceBox":
                return WaveshaperDeviceBox.create(graph, uuid, constructor);
            case "WerkstattDeviceBox":
                return WerkstattDeviceBox.create(graph, uuid, constructor);
            case "WerkstattParameterBox":
                return WerkstattParameterBox.create(graph, uuid, constructor);
            case "WerkstattSampleBox":
                return WerkstattSampleBox.create(graph, uuid, constructor);
            case "SpielwerkDeviceBox":
                return SpielwerkDeviceBox.create(graph, uuid, constructor);
            case "ApparatDeviceBox":
                return ApparatDeviceBox.create(graph, uuid, constructor);
            case "CubedDeviceBox":
                return CubedDeviceBox.create(graph, uuid, constructor);
            case "NoopInstrumentBox":
                return NoopInstrumentBox.create(graph, uuid, constructor);
            case "CompositeDeviceBox":
                return CompositeDeviceBox.create(graph, uuid, constructor);
            case "CompositeCellBox":
                return CompositeCellBox.create(graph, uuid, constructor);
            case "AudioEffectCompositeBox":
                return AudioEffectCompositeBox.create(graph, uuid, constructor);
            case "AudioEffectCompositeCellBox":
                return AudioEffectCompositeCellBox.create(graph, uuid, constructor);
            case "StereoCompositeBox":
                return StereoCompositeBox.create(graph, uuid, constructor);
            case "FrequencySplitBox":
                return FrequencySplitBox.create(graph, uuid, constructor);
            case "ModularBox":
                return ModularBox.create(graph, uuid, constructor);
            case "ModuleConnectionBox":
                return ModuleConnectionBox.create(graph, uuid, constructor);
            case "ModularAudioInputBox":
                return ModularAudioInputBox.create(graph, uuid, constructor);
            case "ModularAudioOutputBox":
                return ModularAudioOutputBox.create(graph, uuid, constructor);
            case "ModuleDelayBox":
                return ModuleDelayBox.create(graph, uuid, constructor);
            case "ModuleMultiplierBox":
                return ModuleMultiplierBox.create(graph, uuid, constructor);
            case "ModuleGainBox":
                return ModuleGainBox.create(graph, uuid, constructor);
            default:
                return panic(`Unknown box class '${name}'`);
        }
    };
    BoxIO.deserialize = (graph, buffer) => {
        const stream = new ByteArrayInput(buffer);
        const className = stream.readString();
        const uuidBytes = UUID.fromDataInput(stream);
        const box = BoxIO.create(className, graph, uuidBytes);
        box.read(stream);
        return box;
    };
})(BoxIO || (BoxIO = {}));
